/* src/app/claim-contract/claim-contract-form/claim-contract-form.component.css */
:host ::ng-deep .p-dropdown {
  width: 100% !important;
  max-width: 100% !important;
}
:host ::ng-deep .p-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .p-toast-detail {
  white-space: pre-line;
}
/*# sourceMappingURL=claim-contract-form.component-67XCVAIF.css.map */
